import { createSlice } from '@reduxjs/toolkit';
import { UserCountersEntity } from '@interpals/api-web';

import { logout } from 'redux/auth/actions';
import { markNotificationsRead, markViewsRead } from 'redux/notifications/actions';

import { getUserCounters, updateCounters, updateNewMessagesCount } from './actions';

export type CountersState = UserCountersEntity;

const initialState = {
    new_friend_requests: 0,
    new_messages: 0,
    new_notifications: 0,
    new_views: 0,
    total_threads: 0,
    unread_threads: 0,
};

export const countersSlice = createSlice({
    name: 'counters',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUserCounters.fulfilled, (_, { payload }) => {
            return payload;
        });

        builder.addCase(updateCounters, (_, { payload }) => {
            return payload;
        });

        builder.addCase(updateNewMessagesCount, (state, { payload }) => {
            return { ...state, new_messages: state.new_messages - payload };
        });

        builder.addCase(markNotificationsRead.fulfilled, (state) => {
            state.new_notifications = 0;
        });

        builder.addCase(markViewsRead.fulfilled, (state) => {
            state.new_views = 0;
        });

        builder.addCase(logout.fulfilled, () => {
            return initialState;
        });
    },
});

export default countersSlice.reducer;
